<template>
  <div v-if="show" class="fixed inset-0 bg-gray-900 bg-opacity-70 flex items-center justify-center p-4 z-50 transition-opacity duration-300">
    <div class="w-full max-w-md bg-gray-800 text-white rounded-lg p-5 flex flex-col gap-4 relative shadow-xl">
      <!-- Header and Close Button -->
      <div class="flex justify-between items-center">
        <h2 class="text-xl font-semibold text-indigo-300" style="font-family: 'Creepster', cursive;">ระบบอาหาร</h2>
        <button @click="$emit('close')" class="text-gray-400 hover:text-indigo-300 transition-colors duration-200">
          <i class="fas fa-times text-lg"></i>
        </button>
      </div>

      <!-- Food System Information -->
      <div class="bg-gray-700 rounded-md p-3 border border-gray-600">
        <p class="text-sm text-indigo-200 mb-2">
          ระดับอาหารของตัวละครจะลดลง <span class="text-yellow-400">10 หน่วย</span> ทุก ๆ 3 ชั่วโมง โดยอัตโนมัติเมื่อตัวละครมีสถานะ <span class="text-green-400">มีชีวิต</span>
        </p>
        <p class="text-sm text-indigo-200 mb-2">
          การลดระดับอาหารจะเกิดขึ้นในช่วงเวลา: <span class="text-yellow-400">00:00, 03:00, 06:00, 09:00, 12:00, 15:00, 18:00, 21:00</span>.
        </p>
        <p class="text-sm text-indigo-200">
          <span class="text-red-400 font-bold">คำเตือน:</span> หากระดับอาหารลดลงถึง <span class="text-yellow-400">0</span> ตัวละครจะเสียชีวิต และต้องรอการเกิดใหม่ โดยจะสูญเสียไอเทม(เสีย 0-1), ทักษะ(เสีย 0), รอยสัก(เสีย 0-1) และห้องจำนวน(เสีย 0-1)
        </p>
      </div>

      <!-- Countdown Timer -->
      <div class="flex items-center justify-between bg-gray-700 rounded-md p-2 border border-gray-600">
        <div class="flex items-center space-x-1">
          <span class="text-sm text-indigo-200">การลดระดับอาหารครั้งต่อไปในอีก:</span>
          <span class="text-sm text-yellow-400 font-bold">{{ countdown }}</span>
        </div>
        <i class="fas fa-clock text-indigo-400 text-xs animate-swing"></i>
      </div>

      <!-- Close Button -->
      <div class="flex justify-center">
        <button @click="$emit('close')" class="bg-indigo-600 hover:bg-indigo-700 text-sm text-white py-2 px-4 rounded-md transition-colors duration-200 flex items-center gap-2">
          <i class="fas fa-times text-xs"></i> ปิด
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';

export default {
  name: 'FoodModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  setup() {
    const countdown = ref('');

    // Countdown logic for next food update
    const updateCountdown = () => {
      const now = new Date();
      const bangkokTime = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Bangkok' }));
      const hours = bangkokTime.getHours();
      const minutes = bangkokTime.getMinutes();
      const seconds = bangkokTime.getSeconds();

      // Calculate the next update time (every 3 hours: 00:00, 03:00, 06:00, 09:00, 12:00, 15:00, 18:00, 21:00)
      const currentHour = Math.floor(hours / 3) * 3;
      const nextUpdateHour = (currentHour + 3) % 24;
      const nextUpdateTime = new Date(bangkokTime);
      nextUpdateTime.setHours(nextUpdateHour, 0, 0, 0);

      if (nextUpdateHour === 0 && hours >= 21) {
        // If the next update is at 00:00 tomorrow
        nextUpdateTime.setDate(nextUpdateTime.getDate() + 1);
      }

      const timeDiff = nextUpdateTime - bangkokTime;
      const hoursLeft = Math.floor(timeDiff / (1000 * 60 * 60));
      const minutesLeft = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      const secondsLeft = Math.floor((timeDiff % (1000 * 60)) / 1000);

      countdown.value = `${hoursLeft.toString().padStart(2, '0')}:${minutesLeft
        .toString()
        .padStart(2, '0')}:${secondsLeft.toString().padStart(2, '0')}`;
    };

    // Update countdown every second
    let countdownInterval = null;
    onMounted(() => {
      updateCountdown();
      countdownInterval = setInterval(updateCountdown, 1000);
    });

    onUnmounted(() => {
      if (countdownInterval) {
        clearInterval(countdownInterval);
      }
    });

    return {
      countdown,
    };
  },
};
</script>

<style scoped>
.animate-swing {
  animation: swing 1s infinite;
}

@keyframes swing {
  0% { transform: rotate(0deg); }
  25% { transform: rotate(15deg); }
  75% { transform: rotate(-15deg); }
  100% { transform: rotate(0deg); }
}

button:not(:disabled):active {
  transform: scale(0.98);
}
</style>